import { StoreApi } from '../../generated/api';
import configuration from './configuration';

export default new StoreApi(configuration);
